export default __webpack_public_path__ + "static/media/glow-dot.583927d9.png";